import { isValidGitPathSegment } from "./gitPath";

// Repo hosts treat owner/repo case-insensitively and a remote may carry a
// trailing slash and/or `.git`; strip slashes before `.git` so a `.git/`
// spelling still matches.
export function canonicalRepoUrl(url: string): string {
  return url
    .trim()
    .toLowerCase()
    .replace(/\/+$/, "")
    .replace(/\.git$/, "");
}

export const GIT_SYNC_ROOT = "/";

/**
 * Normalize a user-entered sync directory to its stored form: `"/"` for the
 * repository root, otherwise slash-joined segments with no surrounding
 * slashes. Returns `undefined` when the input is not a valid path.
 */
export function normalizeGitSyncDirectory(
  input: string | undefined
): string | undefined {
  if (input === undefined) return GIT_SYNC_ROOT;
  const segments = input.split("/").filter((s) => s !== "");
  if (segments.length === 0) return GIT_SYNC_ROOT;
  if (!segments.every(isValidGitPathSegment)) return undefined;
  return segments.join("/");
}

export function gitSyncDirectorySegments(directory: string): string[] {
  return directory === GIT_SYNC_ROOT ? [] : directory.split("/");
}

// Two spaces may share a repository only when neither subtree contains the
// other; the root contains everything.
export function gitSyncDirectoriesOverlap(a: string, b: string): boolean {
  if (a === GIT_SYNC_ROOT || b === GIT_SYNC_ROOT) return true;
  return a === b || a.startsWith(`${b}/`) || b.startsWith(`${a}/`);
}
